import { api } from "../AxiosInstance";
import rbacUtils from "../utils/rbacUtils";

// Define service functions for general data related API calls
const TransporterService = {
  getMyBaseStation: async () => {
    const response = await api.get("/transporter/base-station");
    if (response.data.error) throw new Error(response.data.message || "Could not load base station");
    return response.data.data;
  },
  setMyBaseStation: async (locationId: number) => {
    const response = await api.put("/transporter/base-station", null, { params: { locationId } });
    if (response.data.error) throw new Error(response.data.message || "Could not save base station");
    return response.data.data;
  },
  getMyTransporters: async (userProfile?: any) => {
    try {
      console.log("User Profile in getMyTransporters:", userProfile);
       const endpoint = userProfile
        ? rbacUtils.getRoleBasedEndpoint(userProfile, "/transporters")
        : "/fed/transporters";
      // const response = await api.get("/fed/transporters");
      const response = await api.get(endpoint);
      return response;
      // return response.data; // Return only the data payload
    } catch (error) {
      console.error("Error fetching transporters:", error);
      throw error; // Re-throw error for global handling if necessary
    } 
  },
  getTransporters: async (userProfile?: any) => {
    try {
      // Use role-based endpoint
      const endpoint = userProfile
        ? rbacUtils.getRoleBasedEndpoint(userProfile, "/transporters")
        : "/enterprise/transporters"; // fallback for backward compatibility

      const response = await api.get(endpoint);
      return response;
    } catch (error) {
      console.error("Error fetching enterprise transporters:", error);
      throw error;
    }
  },
  getTrucksByTransporterId: async (transporterId: number) => {
    try {
      const response = await api.get(
        `/fed/transporter/trucks?transporterId=${transporterId}`
      );
      return response;
    } catch (error) {
      console.error("Error fetching trucks:", error);
      throw error;
    }
  },
  getAllDrivers: async () => {
    try {
      const response = await api.get("/driver");
      return response;
    } catch (error) {
      console.error("Error fetching drivers:", error);
      throw error;
    }
  },
  updateDriverTruck: async (driverId: number, newTruckNumber: string) => {
    try {
      const response = await api.put("/driver/update-truck", {
        driverId,
        newTruckNumber,
      });
      return response;
    } catch (error) {
      console.error("Error updating driver truck:", error);
      throw error;
    }
  },
  // Create a new transporter
  createTransporter: async (transporterData: any) => {
    try {
      const response = await api.post(
        "/enterprise/transporters",
        transporterData
      );
      return response.data;
    } catch (error) {
      console.error("Error creating transporter:", error);
      throw error;
    }
  },
  // Create a new transporter (federation admin)
  createFederationTransporter: async (transporterData: any) => {
    try {
      const response = await api.post("/fed/transporters", transporterData);
      return response.data;
    } catch (error) {
      console.error("Error creating federation transporter:", error);
      throw error;
    }
  },
  // Update an existing transporter
  updateTransporter: async (id: number, transporterData: any) => {
    try {
      const response = await api.put(
        `/enterprise/transporters/${id}`,
        transporterData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating transporter:", error);
      throw error;
    }
  },
  // Update an existing transporter (federation admin)
  updateFederationTransporter: async (id: number, transporterData: any) => {
    try {
      const response = await api.put(
        `/fed/transporters/${id}`,
        transporterData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating federation transporter:", error);
      throw error;
    }
  },
  // Delete a transporter
  deleteTransporter: async (id: number) => {
    try {
      const response = await api.delete(`/enterprise/transporters/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting transporter:", error);
      throw error;
    }
  },
  // Delete a transporter (federation admin)
  deleteFederationTransporter: async (id: number) => {
    try {
      const response = await api.delete(`/fed/transporters/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting federation transporter:", error);
      throw error;
    }
  },
  // Create Transporter Admin Registration (Enterprise Transporter)
  createTransporterAdmin: async (data: any) => {
    try {
      const response = await api.post(
        "/enterprise/registration/transporter-admin",
        {
          name: data.name,
          username: data.username,
          email: data.email,
          password: data.password,
          phoneNumber: data.phoneNumber,
          identifier: data.identifier,
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Error creating transporter admin:", error);
      throw error;
    }
  },

  getFederationTransporters: async () => {
    try {
      const response = await api.get("/fed/transporters");
      return response.data;
    } catch (error) {
      console.error("Error fetching federation transporters:", error);
      throw error;
    }
  },
};

export default TransporterService;
